import { Component, OnInit, Inject, EventEmitter, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ViewChild } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
@Component({
  selector: 'app-upload-image-dialog',
  templateUrl: './upload-image-dialog.component.html',
  styleUrls: ['./upload-image-dialog.component.css']
})
export class UploadImageDialogComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  dialogData !: any;
  IsUploadFile = true;
  @ViewChild('myInput') myInputVariable!: any;
  constructor(private dialogRef: MatDialogRef<UploadImageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  , private notification: NotificationService) {
  }

  public event: EventEmitter<any> = new EventEmitter();


  ngOnInit() {
    // this.croppedImage = this.data; //used for show current image into popup
    this.dialogRef.afterClosed().subscribe((res: any) => {
      this.dialogData = res;
     });
  }
  onclose()  {
    this.dialogRef.afterClosed().subscribe((res: any) => {
      this.dialogData =  res;
     });
  }
  fileChangeEvent(event: any): void {
    for (let i = 0; i < event.target.files.length; i++) {
      const name = event.target.files[i].name;
      const type = event.target.files[i].type;
      const size = event.target.files[i].size;
      if (type !== 'image/jpeg' && type !==  'image/jpg' && type !==  'image/png')      {
        this.myInputVariable.nativeElement.value = '';
        this.IsUploadFile = true;
        this.notification.info('Invalid type file', 'Type');
      return;
      }
      if ( Math.round(size / 1024) >= 2048) {
        this.myInputVariable.nativeElement.value = '';
        this.IsUploadFile = true;
        this.notification.info('Size must be less than 2 Mb', 'Size');
      return;
      } else {
        this.IsUploadFile = false;
        this.imageChangedEvent = event;
      }
    }
  }

imageCropped(image: ImageCroppedEvent) {
    if (image.base64) {
      this.croppedImage = image.base64;
      this.data = image.base64;
    } else if (image.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.croppedImage = reader.result as string;
        this.data = reader.result as string;
      };
      reader.readAsDataURL(image.blob);
    }
}
imageLoaded() {
  this.cropperReady = true;
}
loadImageFailed () {
  console.log('Load failed');
}
triggerEvent() {
  this.event.emit({data: this.data});
}

}
